<template>
    <div class="qrcode-poper">
        <img :src="img" alt="" />
    </div>
</template>
<script>
export default {
    name: 'QrcodePoper',
    props: {
        img: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: ''
        }
    },
    computed: {
        showText() {
            let ret = '';
            switch (this.type) {
                case '企业公众号':
                    ret = '关注公众号';
                    break;
                case '企业小程序':
                    ret = '打开小程序';
                    break;
                case '企业群':
                    ret = '加入企业群';
                    break;
                default:
            }
            return `扫码${ret}`;
        }
    }
};
</script>
<style lang="less">
.qrcode-poper {
    font-size: 12px;
    text-align: center;

    img {
        width: 100px;
        height: 100px;
    }
}

.qrcode-poper-wrapper {
    height: 140px;
    width: 120px;
    padding: 10px 10px 6px;
    border-radius: 6px;
    box-sizing: border-box;
}
</style>
